module.exports = __webpack_public_path__ + "img/banner_covid_horizontal.726a048c.jpg";